import moment from 'moment';

export const Header = {
    value: '$$default',
    align: 'center',
    width: '170px',
    sortable: false,
};

export const DateHeader = {
    ...Header,
    value: '$$date',
    width: '225px',
};

export const ActionHeader = {
    ...Header,
    text: 'Actions',
    value: '$$actions',
    cellClass: 'action-class',
};

export const IsActiveHeader = {
    ...Header,
    text: 'Active',
    value: '$$toggle',
    valueFrom: 'isActive',
    cellClass: 'data-table__is-active',
};

export const CreatedAtHeader = {
    ...DateHeader,
    text: 'Created At',
    valueFrom: 'createdAt',
};
export const PercentageHeader = {
    ...Header,
    text: 'Percentage',
    value: '$$percentage',
    valueFrom: 'percentage',
};
export const AmountHeader = {
    ...Header,
    text: 'Amount',
    value: '$$amount',
    valueFrom: 'amount',
};
export const FromHeader = {
    ...DateHeader,
    text: 'From',
    valueFrom: 'from',
};
export const ToHeader = {
    ...DateHeader,
    text: 'To',
    valueFrom: 'to',
};
export const FirstNameHeader = {
    ...Header,
    text: 'First Name',
    value: '$$redirectedTo',
    valueFrom: 'firstName',
};
export const LastNameHeader = {
    ...Header,
    text: 'Last Name',
    valueFrom: 'lastName',
};
export const NameHeader = {
    ...Header,
    text: 'Name',
    valueFrom: 'name',
};
export const EmailHeader = {
    ...Header,
    text: 'Email',
    valueFrom: 'email',
};
export const EditHeader = {
    ...Header,
    text: 'Edit',
};

export const StatusFilters = [
    {
        key: 'isActive',
        label: 'Statuses',
        placeholder: 'Select Statuses',
        values: [
            {
                label: 'Active',
                value: true,
            },
            {
                label: 'In Active',
                value: false,
            },
        ],
    },
];

export const ActionDefaults = {
    create: { name: 'CREATE', title: '+Add', color: 'primary', icon: '' },
    edit: { name: 'EDIT', title: 'Edit', color: 'accent', icon: 'mdi-pencil' },
    delete: {
        name: 'DELETE',
        title: 'Delete',
        color: 'error',
        icon: 'mdi-delete',
        isConfirmationRequired: true,
    },
    complete: {
        name: 'COMPLETE',
        title: 'Complete',
        color: 'warning',
        icon: 'mdi-check',
        isConfirmationRequired: true,
    },
    cancelled: {
        name: 'CANCELLED',
        title: 'cancel',
        color: 'secondary',
        icon: 'mdi-cancel',
        isConfirmationRequired: true,
    },
    view: { name: 'VIEW', title: 'View', color: 'primary', icon: 'mdi-eye' },
    addAddons: {
        name: 'ADD_ADDONS',
        title: ' Add Addon',
        color: 'primary',
        icon: 'mdi-alarm-plus',
    },
    viewImage: {
        name: 'VIEW_IMAGE',
        title: 'Image',
        color: 'accent',
        icon: 'mdi-eye',
    },
    duplicate: {
        name: 'DUPLICATE',
        title: 'Duplicate',
        color: 'warning',
        icon: 'mdi-content-duplicate',
    },
    assignDriver: {
        name: 'ASSIGN_DRIVER',
        title: 'Assign',
        color: 'secondary',
        icon: 'mdi-hand-pointing-right',
    },
};

export const Actions = [
    {
        ...ActionDefaults.create,
    },
    {
        ...ActionDefaults.edit,
    },
    {
        ...ActionDefaults.delete,
    },
];

export const DefaultFromFunction = (val, field, payload) => {
    return !payload.to ? val >= moment().format('yyyy-MM-DD') : val <= payload.to;
};
export const DefaultToFunction = (val, field, payload) => {
    return payload.from ? val >= payload.from : moment().format('yyyy-MM-DD');
};
